
export const buttons = {
  submit: 'Submit',
  cancel: 'Cancel',
  continue: 'Continue',
  back: 'Back',
  next: 'Next',
  finish: 'Finish',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  confirm: 'Confirm',
  close: 'Close',
  retry: 'Retry',
  loading: 'Loading...',
  cognitiveAssessment: 'Start Cognitive Assessment',
  behavioralAssessment: 'Start Behavioral Assessment',
  downloadPDF: 'Download PDF',
  print: 'Print',
  share: 'Share',
  startAssessment: 'Start Assessment',
  completeAssessment: 'Complete Assessment',
  retakeAssessment: 'Retake Assessment',
  viewResults: 'View Results',
  backToHome: 'Back to Home'
};

export const language = {
  select: 'Select Language',
  english: 'English',
  portuguese: 'Português',
  spanish: 'Español'
};

export const userForm = {
  title: 'Complete Your Profile',
  subtitle: 'Please provide your information to receive your personalized results',
  fullName: 'Full Name',
  fullNamePlaceholder: 'Enter your full name',
  email: 'Email Address',
  emailPlaceholder: 'Enter your email address',
  language: 'Preferred Language',
  continue: 'Continue to Results',
  required: 'Required field'
};

export const errors = {
  // Generic errors
  generic: 'Something didn\'t work. Try again?',
  network: 'Connection issue. Check your internet and try again.',
  validation: 'Check your input and try again.',
  unauthorized: 'Please sign in to continue.',
  notFound: 'We couldn\'t find that.',
  serverError: 'Something went wrong on our end. Try again in a moment.',
  
  // Specific operations
  loadingFailed: 'We couldn\'t load this. Refresh to try again.',
  saveFailed: 'Your changes weren\'t saved. Try again?',
  deleteFailed: 'This wasn\'t deleted. Try again?',
  
  // Assessment errors
  assessmentError: 'Assessment didn\'t submit. Your answers are saved. Try again?',
  assessmentLoadFailed: 'We couldn\'t load the assessment. Refresh to try again.',
  
  // Profile errors
  profileLoadFailed: 'We couldn\'t load your profile. Refresh to try again.',
  profileSaveFailed: 'Your profile changes weren\'t saved. Try again?',
  
  // Company errors
  companyCreateFailed: 'We couldn\'t create the company. Check the details and try again.',
  companyLoadFailed: 'We couldn\'t load company data. Refresh to try again.',
  
  // Form errors
  emailInvalid: 'Enter a valid email address.',
  emailRequired: 'Email is required.',
  nameRequired: 'Name is required.',
  nameTooLong: 'Name must be less than 100 characters.',
  messageTooLong: 'Message must be less than 1000 characters.',
  fieldRequired: 'This field is required.',
  
  // Session errors
  sessionExpired: 'Your session expired. Please sign in again.',
  translationMissing: 'Translation missing',
  invalidData: 'Invalid data provided'
};

export const common = {
  loading: 'Loading...',
  saving: 'Saving...',
  success: 'Success!',
  error: 'Error',
  warning: 'Warning',
  info: 'Information',
  yes: 'Yes',
  no: 'No',
  ok: 'OK',
  or: 'or',
  and: 'and',
  of: 'of',
  to: 'to',
  from: 'from',
  in: 'in',
  at: 'at',
  on: 'on',
  with: 'with',
  without: 'without',
  page: 'Page',
  total: 'Total',
  count: 'Count',
  date: 'Date',
  time: 'Time',
  name: 'Name',
  description: 'Description',
  status: 'Status',
  type: 'Type',
  category: 'Category',
  priority: 'Priority',
  search: 'Search',
  filter: 'Filter',
  sort: 'Sort',
  export: 'Export',
  import: 'Import',
  copy: 'Copy',
  paste: 'Paste',
  cut: 'Cut',
  undo: 'Undo',
  redo: 'Redo',
  refresh: 'Refresh',
  reset: 'Reset',
  clear: 'Clear',
  select: 'Select',
  selectAll: 'Select All',
  none: 'None',
  all: 'All',
  more: 'More',
  less: 'Less',
  show: 'Show',
  hide: 'Hide',
  expand: 'Expand',
  collapse: 'Collapse',
  open: 'Open',
  close: 'Close',
  min: 'Min',
  max: 'Max',
  avg: 'Avg',
  today: 'Today',
  yesterday: 'Yesterday',
  tomorrow: 'Tomorrow',
  week: 'Week',
  month: 'Month',
  year: 'Year',
  hour: 'Hour',
  minute: 'Minute',
  second: 'Second',
  am: 'AM',
  pm: 'PM',
  learnMore: 'Learn more',
  switch: 'Switch',
  completedOn: 'Completed on',
  model: 'Model'
};
